/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface selectedProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const selected: React.FC<selectedProps> = ({size, ...props}) => (
  <svg viewBox="0.002 0 10.999 8.001" fill="currentColor" width={ size || "11" } height={ size || "8" } {...props}>
    <path d="M4.847 7.34c-.08.208-.23.393-.444.516a1.07 1.07 0 01-1.436-.344l-.018-.03-2.817-3.06a.986.986 0 01.407-1.368 1.07 1.07 0 011.405.362l1.89 2.052L9.194.313a1.077 1.077 0 011.48-.037.98.98 0 010 1.46L4.847 7.339z"
      fill="currentColor" fillRule="evenodd" />
  </svg>
);
selected.displayName = 'selected';
export default selected;
/* tslint:enable */
/* eslint-enable */
